import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, ClipboardList, Building2, CalendarCog, Zap, BarChart3, Globe, Dumbbell, ChevronRight } from 'lucide-react';
import '../styles/home-selector.css';

const CATEGORIES = [
  { key: 'acro', name: 'ACRO', logo: '/acro.png' },
  { key: 'aer', name: 'AER', logo: '/aer.png' },
  { key: 'gaf', name: 'GAF', logo: '/gaf.png' },
  { key: 'gam', name: 'GAM', logo: '/gam.png' },
  { key: 'gpt', name: 'GPT', logo: '/gpt.png' },
  { key: 'gr', name: 'GR', logo: '/gr.png' },
  { key: 'gt', name: 'GT', logo: '/gt.png' },
  { key: 'pk', name: 'PK', logo: '/pk.png' },
];

const HomeSelector = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const IMPACT_STATS = [
    { icon: Zap, text: 'Resultados de copas en segundos' },
    { icon: BarChart3, text: 'Automatización de clubes' },
    { icon: Globe, text: isMobile ? 'Adaptado a niveles USAG Oficiales' : 'Adaptado a niveles USAG Oficiales' },
  ];

  return (
    <div className="home-container">
      <div className="home-card">
        {/* Hero Section */}
        <div className="home-header">
          <div className="home-header-content">
            <img src="/logocopagimnastahome.png" alt="CopaGimnasta - Software de gestión para copas de gimnasia" className="home-logo-main" />
           <p className="home-subheadline">
              Organiza y gestiona clubes, entrenadores y copas de gimnasia artística, aeróbica, parkour y más.
              <br />
              Puntajes en vivo, ponderaciones de jueces y resultados automáticos.
            </p>
          </div>
        </div>

        {/* Impact Stats */}
        <div className="home-impact">
          {IMPACT_STATS.map((stat, i) => (
            <div key={i} className="home-impact-item">
              <stat.icon size={20} />
              <span>{stat.text}</span>
            </div>
          ))}
        </div>

        {/* Banner Resultados en Vivo */}
        <button
          type="button"
          onClick={() => navigate('/resultados')}
          className="home-results-banner"
        >
          <div className="results-banner-icon">
            <Eye size={28} />
          </div>
          <div className="results-banner-text">
            <h3>Resultados en Vivo</h3>
            <p>Visualización instantánea de puntajes para público y entrenadores</p>
          </div>
          <div className="results-banner-action">
            <span>Acceso público</span>
            <ChevronRight size={18} />
          </div>
        </button>

        {/* Feature Cards - 4 plataformas */}
        <div className="home-options">
          <button
            type="button"
            onClick={() => navigate('/jueces', { replace: false })}
            className="home-option jueces-option"
          >
            <div className="option-icon">
              <ClipboardList size={28} />
            </div>
            <h3>Portal de Jueces</h3>
            <p>Ingreso de puntuaciones desde cualquier dispositivo</p>
            <span className="access-label auth-label">Requiere login</span>
          </button>

          <button
            type="button"
            onClick={() => navigate('/clubes', { replace: false })}
            className="home-option clubes-option"
          >
            <div className="option-icon">
              <Building2 size={28} />
            </div>
            <h3>Portal de Clubes</h3>
            <p>Control de asistencia, métricas, información e inscripción en competiciones</p>
            <span className="access-label auth-label">Requiere login</span>
          </button>

          <button
            type="button"
            onClick={() => navigate('/entrenadores', { replace: false })}
            className="home-option entrenadores-option"
          >
            <div className="option-icon">
              <Dumbbell size={28} />
            </div>
            <h3>Portal de Entrenadores</h3>
            <p>Perfil profesional, gestión de clubes y ofertas de empleo</p>
            <span className="access-label auth-label">Requiere login</span>
          </button>

          <button
            type="button"
            onClick={() => navigate('/organizador', { replace: false })}
            className="home-option organizador-option"
          >
            <div className="option-icon">
              <CalendarCog size={28} />
            </div>
            <h3>Organizar Copa</h3>
            <p>Creación, control y configuración de copas y Competiciones</p>
            <span className="access-label auth-label">Requiere login</span>
          </button>
        </div>

        {/* Category Logos Strip */}
        <div className="home-categories">
          {CATEGORIES.map(cat => (
            <div key={cat.key} className="home-category-item">
              <img src={cat.logo} alt={cat.name} className="home-category-logo" />
              <span className="home-category-name">{cat.name}</span>
            </div>
          ))}
        </div>
        <p className="home-copyright">© {new Date().getFullYear()} CopaGimnasta. Todos los derechos reservados.</p>
      </div>
    </div>
  );
};

export default HomeSelector;
